module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Klaim ")]), _vm._v(" "), _c('div', [_c('ButtonGroup', [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.changeMarkingType('marking')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back"
    }
  }), _vm._v("\n                    Marking\n                ")], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.changeMarkingType('markingGroup')
      }
    }
  }, [_vm._v("\n                    Marking Group\n                    "), _c('Icon', {
    attrs: {
      "type": "ios-arrow-forward"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('transition', {
    attrs: {
      "name": "move-right"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.markingShow),
      expression: "markingShow"
    }]
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Marking")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingMarking
    },
    on: {
      "on-change": function($event) {
        return _vm.getClaimMarking()
      }
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                                    " + _vm._s(option.label))])
  }), 1)], 1)], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-right"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.markingGroupShow),
      expression: "markingGroupShow"
    }]
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Marking Group")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "remote-method": _vm.getMarkingGroupByCode,
      "loading": _vm.isLoadingMarking
    },
    on: {
      "on-change": function($event) {
        return _vm.changeMarkingGroupHandle()
      }
    },
    model: {
      value: (_vm.markingGroupIdSelected),
      callback: function($$v) {
        _vm.markingGroupIdSelected = $$v
      },
      expression: "markingGroupIdSelected"
    }
  }, _vm._l((_vm.optionMarkingGroups), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                                    " + _vm._s(option.label))])
  }), 1)], 1)], 1)])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingMarking),
      expression: "isLoadingMarking"
    }],
    attrs: {
      "size": "large"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.markingShow),
      expression: "markingShow"
    }]
  }, [_c('Table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceClaimData.length > 0),
      expression: "invoiceClaimData.length > 0"
    }],
    attrs: {
      "border": "",
      "columns": _vm.columnsDataTable,
      "data": _vm.invoiceClaimData
    }
  })], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.markingGroupShow),
      expression: "markingGroupShow"
    }]
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataClaimSelected.length > 0),
      expression: "dataClaimSelected.length > 0"
    }],
    staticClass: "ivu-btn ivu-btn-success ivu-btn-small",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showAddClaimHandle
    }
  }, [_c('span', [_vm._v("Tambah claim: " + _vm._s(_vm.dataClaimSelected.length))])]), _vm._v(" "), _c('Tabs', {
    attrs: {
      "animated": false
    },
    on: {
      "on-click": _vm.groupClickHandle
    },
    model: {
      value: (_vm.markingActiveGroup),
      callback: function($$v) {
        _vm.markingActiveGroup = $$v
      },
      expression: "markingActiveGroup"
    }
  }, _vm._l((_vm.listMarkingGroup), function(marking) {
    return _c('TabPane', {
      key: marking.markingheaderid,
      attrs: {
        "label": marking.markingheadercode,
        "name": marking.markingheaderid.toString()
      }
    }, [_c('p', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(" Daftar Klaim ")]), _vm._v(" "), _c('Table', {
      attrs: {
        "border": "",
        "columns": _vm.columnsDataTableGroup,
        "data": _vm.invoiceClaimDataGroup
      }
    })], 1)
  }), 1)], 1)], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "60%"
    },
    model: {
      value: (_vm.isModalUploadFile),
      callback: function($$v) {
        _vm.isModalUploadFile = $$v
      },
      expression: "isModalUploadFile"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tambah Klaim")])], 1), _vm._v(" "), _c('Form', {
    ref: "formAdd",
    attrs: {
      "model": _vm.formAdd,
      "rules": _vm.ruleValidateClaim
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Tanggal & No. Partai"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formAdd.invoiceDateContainerCode),
      callback: function($$v) {
        _vm.$set(_vm.formAdd, "invoiceDateContainerCode", $$v)
      },
      expression: "formAdd.invoiceDateContainerCode"
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formAdd.markingHeaderId),
      callback: function($$v) {
        _vm.$set(_vm.formAdd, "markingHeaderId", $$v)
      },
      expression: "formAdd.markingHeaderId"
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formAdd.receivableId),
      callback: function($$v) {
        _vm.$set(_vm.formAdd, "receivableId", $$v)
      },
      expression: "formAdd.receivableId"
    }
  })], 1), _vm._v(" "), _c('FormItem', [_c('Row', [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v("\n                    Tanggal Klaim\n                    ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4",
      "offset": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Row', [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "readonly": "",
      "type": "date",
      "placeholder": "Tanggal Klaim",
      "format": "yyyy/MM/dd"
    },
    model: {
      value: (_vm.formAdd.claimDate),
      callback: function($$v) {
        _vm.$set(_vm.formAdd, "claimDate", $$v)
      },
      expression: "formAdd.claimDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Kode Penyesuaian",
      "prop": "categoryCodeId"
    }
  }, [_c('br'), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "80%",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Select",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.formAdd.categoryCodeId),
      callback: function($$v) {
        _vm.$set(_vm.formAdd, "categoryCodeId", $$v)
      },
      expression: "formAdd.categoryCodeId"
    }
  }, _vm._l((_vm.categoriesCode), function(category) {
    return _c('Option', {
      key: category.id,
      attrs: {
        "value": category.id
      }
    }, [_vm._v(_vm._s(category.category))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Bank",
      "prop": "bankAccountId"
    }
  }, [_c('br'), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "80%",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Pilih Rekening Bank",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "on-change": function($event) {
        return _vm.changeBankAccount()
      }
    },
    model: {
      value: (_vm.formAdd.bankAccountId),
      callback: function($$v) {
        _vm.$set(_vm.formAdd, "bankAccountId", $$v)
      },
      expression: "formAdd.bankAccountId"
    }
  }, _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('Option', {
      key: bankAccount.id,
      attrs: {
        "value": bankAccount.id
      }
    }, [_vm._v(_vm._s(bankAccount.accountName) + "\n                    ")])
  }), 1)], 1), _vm._v(" "), _c('FormItem', [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v("\n                    Category Klaim\n                    ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_vm._v("\n                    Nilai Klaim\n                    ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v("\n                    Keterangan\n                    ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.formAdd.formDynamic.items), function(item, index) {
    return [(item.status) ? _c('FormItem', {
      key: index
    }, [_c('Row', {
      attrs: {
        "type": "flex",
        "justify": "space-between"
      }
    }, [_c('Col', {
      attrs: {
        "span": "8"
      }
    }, [_c('Select', {
      attrs: {
        "placeholder": "Select",
        "clearable": "",
        "filterable": ""
      },
      model: {
        value: (_vm.formAdd.formDynamic.items[index].categoryClaimId),
        callback: function($$v) {
          _vm.$set(_vm.formAdd.formDynamic.items[index], "categoryClaimId", $$v)
        },
        expression: "formAdd.formDynamic.items[index].categoryClaimId"
      }
    }, _vm._l((_vm.categoryClaims), function(categoryClaim) {
      return _c('Option', {
        key: categoryClaim.id,
        attrs: {
          "value": categoryClaim.id
        }
      }, [_vm._v("  " + _vm._s(((categoryClaim.code) + ". " + (categoryClaim.name) + " ")))])
    }), 1)], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "5"
      }
    }, [(_vm.isSpecialMarking) ? _c('Money', _vm._b({
      staticClass: "ivu-input",
      model: {
        value: (_vm.formAdd.formDynamic.items[index].claimValue),
        callback: function($$v) {
          _vm.$set(_vm.formAdd.formDynamic.items[index], "claimValue", $$v)
        },
        expression: "formAdd.formDynamic.items[index].claimValue"
      }
    }, 'Money', _vm.moneySG, false)) : _c('Money', _vm._b({
      staticClass: "ivu-input",
      model: {
        value: (_vm.formAdd.formDynamic.items[index].claimValue),
        callback: function($$v) {
          _vm.$set(_vm.formAdd.formDynamic.items[index], "claimValue", $$v)
        },
        expression: "formAdd.formDynamic.items[index].claimValue"
      }
    }, 'Money', _vm.money, false))], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "8"
      }
    }, [_c('Input', {
      model: {
        value: (_vm.formAdd.formDynamic.items[index].description),
        callback: function($$v) {
          _vm.$set(_vm.formAdd.formDynamic.items[index], "description", $$v)
        },
        expression: "formAdd.formDynamic.items[index].description"
      }
    })], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.handleRemove(index)
        }
      }
    }, [_vm._v("Delete")])], 1)], 1)], 1) : _vm._e()]
  }), _vm._v(" "), _c('FormItem', [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(" + Tambah Nilai Klaim")])], 1), _vm._v(" "), _c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.claimValueTotal),
      expression: "claimValueTotal"
    }],
    attrs: {
      "span": "14"
    }
  }, [_c('b', [_vm._v("\n                        Total Nilai Klaim :\n                        "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.claimValueTotal) + " ")])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingUploadFile
    },
    on: {
      "click": _vm.postUploadFile
    }
  }, [(!_vm.isLoadingUploadFile) ? _c('span', [_vm._v("Simpan")]) : _c('span', [_vm._v("Uploading.....")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "50%"
    },
    model: {
      value: (_vm.isModalAddClaimGroup),
      callback: function($$v) {
        _vm.isModalAddClaimGroup = $$v
      },
      expression: "isModalAddClaimGroup"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tambah Klaim Group")])], 1), _vm._v(" "), _c('Form', {
    ref: "formAddGroup",
    attrs: {
      "model": _vm.formAddGroup,
      "rules": _vm.ruleValidateClaim
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Tanggal Klaim"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "75%",
      "display": "revert"
    },
    attrs: {
      "disabled": "",
      "type": "date",
      "placeholder": "Tanggal Klaim",
      "format": "yyyy/MM/dd"
    },
    model: {
      value: (_vm.formAddGroup.claimDate),
      callback: function($$v) {
        _vm.$set(_vm.formAddGroup, "claimDate", $$v)
      },
      expression: "formAddGroup.claimDate"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Kode Penyesuaian",
      "prop": "categoryCodeId"
    }
  }, [_c('br'), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "80%",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Select",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.formAddGroup.categoryCodeId),
      callback: function($$v) {
        _vm.$set(_vm.formAddGroup, "categoryCodeId", $$v)
      },
      expression: "formAddGroup.categoryCodeId"
    }
  }, _vm._l((_vm.categoriesCode), function(category) {
    return _c('Option', {
      key: category.id,
      attrs: {
        "value": category.id
      }
    }, [_vm._v(_vm._s(category.category))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Bank",
      "prop": "bankAccountId"
    }
  }, [_c('br'), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "80%",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Pilih Rekening Bank",
      "clearable": ""
    },
    on: {
      "on-change": function($event) {
        return _vm.changeBankAccount()
      }
    },
    model: {
      value: (_vm.formAddGroup.bankAccountId),
      callback: function($$v) {
        _vm.$set(_vm.formAddGroup, "bankAccountId", $$v)
      },
      expression: "formAddGroup.bankAccountId"
    }
  }, _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('Option', {
      key: bankAccount.id,
      attrs: {
        "value": bankAccount.id
      }
    }, [_vm._v(_vm._s(bankAccount.accountName) + "\n                    ")])
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.formAddGroup.listClaim), function(value, i) {
    return [_c('Card', [_c('Form-item', {
      attrs: {
        "label": "Tanggal & No. Partai"
      }
    }, [_c('Input', {
      attrs: {
        "disabled": ""
      },
      model: {
        value: (value.invoiceDateContainerCode),
        callback: function($$v) {
          _vm.$set(value, "invoiceDateContainerCode", $$v)
        },
        expression: "value.invoiceDateContainerCode"
      }
    }), _vm._v(" "), _c('Input', {
      staticStyle: {
        "display": "none"
      },
      model: {
        value: (value.markingHeaderId),
        callback: function($$v) {
          _vm.$set(value, "markingHeaderId", $$v)
        },
        expression: "value.markingHeaderId"
      }
    }), _vm._v(" "), _c('Input', {
      staticStyle: {
        "display": "none"
      },
      model: {
        value: (value.receivableId),
        callback: function($$v) {
          _vm.$set(value, "receivableId", $$v)
        },
        expression: "value.receivableId"
      }
    })], 1), _vm._v(" "), _c('Form-item', {
      attrs: {
        "label": "Marking Header Code"
      }
    }, [_c('Input', {
      attrs: {
        "disabled": ""
      },
      model: {
        value: (value.markingHeaderCode),
        callback: function($$v) {
          _vm.$set(value, "markingHeaderCode", $$v)
        },
        expression: "value.markingHeaderCode"
      }
    })], 1), _vm._v(" "), _c('FormItem', [_c('Row', {
      attrs: {
        "type": "flex",
        "justify": "space-between"
      }
    }, [_c('Col', {
      attrs: {
        "span": "8"
      }
    }, [_vm._v("\n                            Category Klaim\n                            ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "5"
      }
    }, [_vm._v("\n                            Nilai Klaim\n                            ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "8"
      }
    }, [_vm._v("\n                            Keterangan\n                            ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "2"
      }
    })], 1)], 1), _vm._v(" "), _vm._l((value.details), function(item, index) {
      return [(item.status) ? _c('FormItem', {
        key: index
      }, [_c('Row', {
        attrs: {
          "type": "flex",
          "justify": "space-between"
        }
      }, [_c('Col', {
        attrs: {
          "span": "8"
        }
      }, [_c('Select', {
        attrs: {
          "placeholder": "Select",
          "clearable": "",
          "filterable": ""
        },
        model: {
          value: (item.categoryClaimId),
          callback: function($$v) {
            _vm.$set(item, "categoryClaimId", $$v)
          },
          expression: "item.categoryClaimId"
        }
      }, _vm._l((_vm.categoryClaims), function(categoryClaim) {
        return _c('Option', {
          key: categoryClaim.id,
          attrs: {
            "value": categoryClaim.id
          }
        }, [_vm._v("  " + _vm._s(((categoryClaim.code) + ". " + (categoryClaim.name) + " ")))])
      }), 1)], 1), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "5"
        }
      }, [(_vm.isSpecialMarking) ? _c('Money', _vm._b({
        staticClass: "ivu-input",
        nativeOn: {
          "focusout": function($event) {
            return _vm.changeClaimValue()
          }
        },
        model: {
          value: (item.claimValue),
          callback: function($$v) {
            _vm.$set(item, "claimValue", $$v)
          },
          expression: "item.claimValue"
        }
      }, 'Money', _vm.moneySG, false)) : _c('Money', _vm._b({
        staticClass: "ivu-input",
        nativeOn: {
          "focusout": function($event) {
            return _vm.changeClaimValue()
          }
        },
        model: {
          value: (item.claimValue),
          callback: function($$v) {
            _vm.$set(item, "claimValue", $$v)
          },
          expression: "item.claimValue"
        }
      }, 'Money', _vm.money, false))], 1), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "8"
        }
      }, [_c('Input', {
        model: {
          value: (item.description),
          callback: function($$v) {
            _vm.$set(item, "description", $$v)
          },
          expression: "item.description"
        }
      })], 1), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "2"
        }
      }, [_c('Button', {
        attrs: {
          "type": "error"
        },
        on: {
          "click": function($event) {
            return _vm.handleRemoveClaimGroup(index, value.receivableId)
          }
        }
      }, [_vm._v("Delete")])], 1)], 1)], 1) : _vm._e()]
    }), _vm._v(" "), _c('FormItem', [_c('Row', {
      attrs: {
        "type": "flex",
        "justify": "space-between"
      }
    }, [_c('Col', {
      attrs: {
        "span": "7"
      }
    }, [_c('Button', {
      attrs: {
        "type": "info"
      },
      on: {
        "click": function($event) {
          return _vm.handleAddClaimGroup(value.receivableId)
        }
      }
    }, [_vm._v(" + Tambah Nilai\n                                Klaim")])], 1), _vm._v(" "), _c('Col', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (value.claimValueTotal),
        expression: "value.claimValueTotal"
      }],
      attrs: {
        "span": "14"
      }
    }, [_c('b', [_vm._v("\n                                Total Nilai Klaim :\n                                "), (_vm.isSpecialMarking) ? _c('Money', _vm._b({
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "disabled": ""
      },
      model: {
        value: (value.claimValueTotal),
        callback: function($$v) {
          _vm.$set(value, "claimValueTotal", $$v)
        },
        expression: "value.claimValueTotal"
      }
    }, 'Money', _vm.moneySG, false)) : _c('Money', _vm._b({
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "disabled": ""
      },
      model: {
        value: (value.claimValueTotal),
        callback: function($$v) {
          _vm.$set(value, "claimValueTotal", $$v)
        },
        expression: "value.claimValueTotal"
      }
    }, 'Money', _vm.money, false))], 1)]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "2"
      }
    })], 1)], 1)], 2), _vm._v(" "), _c('br')]
  })], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingUploadFile
    },
    on: {
      "click": _vm.postClaimGroup
    }
  }, [(!_vm.isLoadingUploadFile) ? _c('span', [_vm._v("Simpan")]) : _c('span', [_vm._v("Uploading.....")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "50%"
    },
    model: {
      value: (_vm.isModalDetail),
      callback: function($$v) {
        _vm.isModalDetail = $$v
      },
      expression: "isModalDetail"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Detail")])], 1), _vm._v(" "), _c('Form', {
    ref: "formAdd",
    attrs: {
      "model": _vm.formAdd
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Tanggal & No. Partai"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formAdd.invoiceDateContainerCode),
      callback: function($$v) {
        _vm.$set(_vm.formAdd, "invoiceDateContainerCode", $$v)
      },
      expression: "formAdd.invoiceDateContainerCode"
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formAdd.markingHeaderId),
      callback: function($$v) {
        _vm.$set(_vm.formAdd, "markingHeaderId", $$v)
      },
      expression: "formAdd.markingHeaderId"
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formAdd.receivableId),
      callback: function($$v) {
        _vm.$set(_vm.formAdd, "receivableId", $$v)
      },
      expression: "formAdd.receivableId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formAdd.description),
      callback: function($$v) {
        _vm.$set(_vm.formAdd, "description", $$v)
      },
      expression: "formAdd.description"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formAdd.claimDetail.length > 0),
      expression: "formAdd.claimDetail.length > 0"
    }]
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_vm._v("\n                    Nilai Klaim\n                    ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12",
      "offset": "1"
    }
  }, [_vm._v("\n                    Keterangan Klaim\n                    ")])], 1)], 1), _vm._v(" "), _vm._l((_vm.formAdd.claimDetail), function(item, index) {
    return [_c('FormItem', [_c('Row', [_c('Col', {
      attrs: {
        "span": "10"
      }
    }, [(_vm.isSpecialMarking) ? _c('Money', _vm._b({
      staticClass: "ivu-input",
      attrs: {
        "readonly": ""
      },
      model: {
        value: (_vm.formAdd.claimDetail[index].claim_value),
        callback: function($$v) {
          _vm.$set(_vm.formAdd.claimDetail[index], "claim_value", $$v)
        },
        expression: "formAdd.claimDetail[index].claim_value"
      }
    }, 'Money', _vm.moneySG, false)) : _c('Money', _vm._b({
      staticClass: "ivu-input",
      attrs: {
        "readonly": ""
      },
      model: {
        value: (_vm.formAdd.claimDetail[index].claim_value),
        callback: function($$v) {
          _vm.$set(_vm.formAdd.claimDetail[index], "claim_value", $$v)
        },
        expression: "formAdd.claimDetail[index].claim_value"
      }
    }, 'Money', _vm.money, false))], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "12",
        "offset": "1"
      }
    }, [_c('Input', {
      attrs: {
        "readonly": ""
      },
      model: {
        value: (_vm.formAdd.claimDetail[index].description),
        callback: function($$v) {
          _vm.$set(_vm.formAdd.claimDetail[index], "description", $$v)
        },
        expression: "formAdd.claimDetail[index].description"
      }
    })], 1)], 1)], 1)]
  }), _vm._v(" "), _c('FormItem', [_c('Row', [_c('Col', {
    attrs: {
      "span": "10",
      "offset": "9"
    }
  }, [_c('b', [_vm._v("\n                        Total Nilai Klaim :\n                        "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.formAdd.totalClaim))])])])], 1)], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4aef3814","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/claim/Claim.vue
// module id = 1802
// module chunks = 1